/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { _date, _fn } from '@mairistem/administres-utils';
import { Table } from '@mairistem/composants';

import type { Acte, TypeActe } from '@/types';

import ActeTableLineDeces from './ActeTableLineDeces';
import ActeTableLineMariage from './ActeTableLineMariage';
import ActeTableLineNaissance from './ActeTableLineNaissance';
import ActeTableLineReconnaissance from './ActeTableLineReconnaissance';

interface Props {
  /**
   * This line's acte
   */
  acte: Acte;
  /**
   * The type of acte currently being displayed.
   */
  typeActe: TypeActe;
  /**
   * Called when a row is clicked.
   *
   * The identifiant is the identifiant of the acte clicked.
   */
  onSelected?: (acte: Acte) => void;
}

const ActeTableLine = (props: Props) => {
  const { acte, typeActe, onSelected } = props;

  let cells: (p: { acte: Acte }) => React.ReactNode;

  switch (typeActe) {
    case 'naissance':
      cells = ActeTableLineNaissance;
      break;
    case 'reconnaissance':
      cells = ActeTableLineReconnaissance;
      break;
    case 'mariage':
      cells = ActeTableLineMariage;
      break;
    case 'deces':
      cells = ActeTableLineDeces;
      break;
    default:
      cells = () => undefined;
      break;
  }

  return (
    <Table.Row
      selectable
      onClick={() => _fn(onSelected, acte)}
      style={{ cursor: 'pointer' }}
    >
      <Table.Cell content={acte.anneeActe} />
      <Table.Cell content={acte.numeroActe} />
      <Table.Cell content={_date.short(acte.dateDresseActe)} />
      {cells({ acte })}
    </Table.Row>
  );
};

export default ActeTableLine;
